import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { FrontpageRoutes } from '@/frontpage/config';
import { ByggRoutes } from '@klp/bygg/config';
import { useAppParams } from '@klp/core/app/useAppParams';
import { Loader } from '@klp/design/Loader';
import { Main } from '@klp/layout';

import { Client } from '../classes';
import { useGetKundeListQuery } from '../clientApi';
import { useSelectClientMutation } from '../components/Select/rtkApi';

export const ByggClientListPreselect: React.FC = () => {
    const [selectClient] = useSelectClientMutation();
    const params = useAppParams();
    const history = useHistory();

    const { data, isLoading: kundeListLoading } = useGetKundeListQuery(
        { kundeNummer: [params.kundeNummer!] },
        {
            skip: !params.kundeNummer,
        },
    );

    useEffect(() => {
        const { kundeNummer, selectedClient } = params;
        const kundeList = data || [];

        if (kundeNummer === undefined) {
            history.push(FrontpageRoutes.frontpage());
            return;
        }

        if (selectedClient?.kundeNummer === kundeNummer) {
            history.push(ByggRoutes.list());
            return;
        }

        const kunde = kundeList?.find((k) => k.kundenummer === kundeNummer);

        if (!kunde) {
            return;
        }

        const client = Client.parseObject({
            kundeName: kunde.navn,
            kundeNummer: kunde.kundenummer,
            isSuperOfficeKunde: kunde.isSuperOfficeKunde,
            isHandelKunde: kunde.isHandelKunde,
            isNaeringKunde: kunde.isNaeringKunde,
        });

        selectClient(client);
        history.push(ByggRoutes.list());

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, params]);

    return (
        <Main>
            <Loader isLoading={kundeListLoading} />
        </Main>
    );
};
